import React, { useCallback } from 'react';

import useUserDateTime from 'hooks/useUserDateTime';
import {
  fetchPaginatedSecurityEventEntities,
  securityEventEntitiesKeyFn,
} from 'security-app/hooks/api/securityEventsAPI';
import type { SearchParams } from 'stores/PaginationTypes';
import PaginatedEntityTable from 'components/common/PaginatedEntityTable';
import EventsRefreshControls from 'components/events/events/EventsRefreshControls';
import QueryHelper from 'components/common/QueryHelper';
import type { SecurityEventEntity } from 'security-app/hooks/api/securityEventsAPI.types';
import { securityEventsTableElements } from 'security-app/components/SecurityEvents/Alerts/Constants';
import columnRenderers from 'security-app/components/SecurityEvents/Alerts/ColumnRenderers';
import useTableElements from 'security-app/components/SecurityEvents/Alerts/hooks/useTableComponents';
import AlertsWidgets from 'security-app/components/SecurityEvents/Alerts/AlertsWidgets';
import EventsRefreshProvider from 'components/events/EventsRefreshProvider';

import FilterValueRenderers from './FilterValueRenderers';

const AlertsEntityTable = () => {
  const { userTimezone } = useUserDateTime();
  const fetchAlerts = useCallback(
    (searchParams: SearchParams) => fetchPaginatedSecurityEventEntities(searchParams, userTimezone),
    [userTimezone],
  );
  const { bulkSelection, expandedSections } = useTableElements({
    defaultLayout: securityEventsTableElements.defaultLayout,
  });

  return (
    <EventsRefreshProvider>
      <PaginatedEntityTable<SecurityEventEntity>
        humanName="security events"
        entityActions={null}
        columnsOrder={securityEventsTableElements.columnOrder}
        queryHelpComponent={<QueryHelper entityName="security event" />}
        tableLayout={securityEventsTableElements.defaultLayout}
        fetchEntities={fetchAlerts}
        keyFn={securityEventEntitiesKeyFn}
        actionsCellWidth={0}
        expandedSectionsRenderer={expandedSections}
        entityAttributesAreCamelCase={false}
        filterValueRenderers={FilterValueRenderers}
        columnRenderers={columnRenderers}
        bulkSelection={bulkSelection}
        topRightCol={<EventsRefreshControls />}
        middleSection={AlertsWidgets}
      />
    </EventsRefreshProvider>
  );
};

export default AlertsEntityTable;
